import { render, staticRenderFns } from "./diet-list.vue?vue&type=template&id=af19d94e&scoped=true&"
import script from "./diet-list.vue?vue&type=script&lang=js&"
export * from "./diet-list.vue?vue&type=script&lang=js&"
import style0 from "./diet-list.vue?vue&type=style&index=0&id=af19d94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af19d94e",
  null
  
)

export default component.exports